import { FlagEnum, Locations, Roles } from "interfaces/enums";
import {
  FileText as Article,
  Building2 as AccountBalance,
  UserCheck as HowToReg,
  Webhook,
  Receipt as RequestQuote,
  Radio as ModeStandby,
  UserPlus,
  ScrollText,
  ArrowRightLeft,
  BarChart,
  Users,
  Landmark,
  LayoutDashboard,
  RefreshCw,
  Handshake,
  Activity,
  ShieldCheck,
} from "lucide-react";

import { ISidebarMenuOptions } from "interfaces/ISidebarMenuOptions";

export const MenuOptions = [
  {
    icon: (props: any) => <LayoutDashboard {...props} />,
    route: Locations["/cockpit"],
    label: "Dashboard",
    // Visible to anyone with any of the main user flags. RoutesPermissions
    // requires showTo to overlap with the user's flags or it redirects, so
    // we list the broad set rather than [] which never matches.
    showTo: [
      FlagEnum.institutional,
      FlagEnum.ccy_conversion_client,
      FlagEnum.ccy_conversion_broker,
      FlagEnum.ccy_conversion_super_broker,
      FlagEnum.ccy_conversion_mex_dollar,
    ],
  },
  {
    icon: (props: any) => <ModeStandby height={22} width={22} {...props} />,
    route: Locations["/ccy-conversion/place-order"],
    showTo: [FlagEnum.ccy_conversion_broker, FlagEnum.ccy_conversion_client],
  },
  // {
  //   icon: (props: any) => <ModeStandby height={22} width={22} {...props} />,
  //   route: Locations["/ccy-conversion/place-order-mexdolar"],
  //   showTo: [FlagEnum.ccy_conversion_mex_dollar],
  // },
  // {
  //   icon: (props: any) => <ModeStandby height={22} width={22} {...props} />,
  //   route: Locations["/ccy-conversion/place-order-batch"],
  //   showTo: [FlagEnum.batch_orders],
  // },
  {
    route: Locations["/ccy-conversion/orders/:id"],
    showTo: [
      FlagEnum.ccy_conversion_client,
      FlagEnum.ccy_conversion_broker,
      FlagEnum.ccy_conversion_super_broker,
    ],
    hideOnNavBar: true,
  },
  {
    icon: (props: any) => <RequestQuote {...props} />,
    route: Locations["/ccy-conversion/orders"],
    showTo: [
      FlagEnum.ccy_conversion_client,
      FlagEnum.ccy_conversion_broker,
      FlagEnum.ccy_conversion_super_broker,
    ],
  },

  {
    icon: (props: any) => <AccountBalance {...props} />,
    route: Locations["/ccy-conversion/destination-bank-accounts-router"],
    showTo: [
      FlagEnum.ccy_conversion_client,
      FlagEnum.ccy_conversion_broker,
      FlagEnum.ccy_conversion_mex_dollar,
    ],
  },
  {
    icon: (props: any) => <Article {...props} />,
    route: Locations["/documentation"],
    showTo: [FlagEnum.institutional],
    requiresPorfolio: true,
  },
  {
    icon: (props: any) => <Handshake {...props} />,
    route: Locations["/leads"],
    // The CRM population is the link-minting population: leads are the
    // mandatory pre-step to /send-onboarding, so both share the same flag.
    showTo: [FlagEnum.leads],
  },
  {
    icon: (props: any) => <HowToReg {...props} />,
    route: Locations["/send-onboarding"],
    showTo: [FlagEnum.send_onboarding],
  },
  {
    icon: (props: any) => <Webhook {...props} />,
    route: Locations["/api-management"],
    showTo: [FlagEnum.api_access],
  },
] as Array<ISidebarMenuOptions>;

export const AdminMenuOptions = [
  {
    icon: (props: any) => <UserPlus {...props} />,
    route: Locations["/admin/onboardings"],
    role: Roles.admin,
    showTo: [FlagEnum.send_onboarding],
  },
  {
    // Compliance case files (engine-backed, RESTRICTED) — admin only, the
    // engine additionally enforces is_admin server-side on its token lane.
    icon: (props: any) => <ShieldCheck {...props} />,
    route: Locations["/admin/compliance"],
    role: Roles.admin,
    showTo: [],
  },
  {
    icon: (props: any) => <ScrollText {...props} />,
    route: Locations["/admin/orders"],
    role: Roles.admin,
    showTo: [],
  },
  {
    icon: (props: any) => <ScrollText {...props} />,
    route: Locations["/admin/create-manual-order"],
    role: Roles.admin,
    showTo: [],
  },
  {
    icon: (props: any) => <ScrollText {...props} />,
    route: Locations["/admin/mexdolar-orders"],
    role: Roles.admin,
    showTo: [], //[FlagEnum.mex_dollar_admin],
  },
  {
    icon: (props: any) => <ArrowRightLeft {...props} />,
    route: Locations["/admin/transfers"],
    role: Roles.admin,
    showTo: [FlagEnum.admin_transfers],
  },
  {
    icon: (props: any) => <BarChart {...props} />,
    route: Locations["/admin/analytics"],
    role: Roles.admin,
    showTo: [],
  },
  {
    icon: (props: any) => <Activity {...props} />,
    route: Locations["/admin/quote-stream"],
    role: Roles.admin,
    showTo: [],
  },
  {
    icon: (props: any) => <Users {...props} />,
    route: Locations["/admin/users"],
    role: Roles.admin,
    showTo: [],
  },
  {
    icon: (props: any) => <Landmark {...props} />,
    route: Locations["/admin/accounts"],
    role: Roles.admin,
    showTo: [],
  },
  {
    icon: (props: any) => <RefreshCw {...props} />,
    route: Locations["/admin/fe-version"],
    role: Roles.admin,
    showTo: [],
  },
] as Array<ISidebarMenuOptions>;
